// Shader mdoules have no exports and should simply be imported to execute their registration
import "./world-2d.shader";
